export const actionTypes = {
    FetchLatestDate: "[FetchLatestDate] Action",
    UpdateLatestDate: "[UpdateLatestDate] Action",
    SetDateRange: "[SetDateRange] Action",
    SetRangeType: "[SetRangeType] Action",
    SetLabelSelected: "[SetLabelSelected] Action",
    ChangeRangeType: "[ChangeRangeType] Action",
};